import tacklebox from "tacklebox";

import { Page } from '@/js/Page.js';

function Expectation(id, title) {
    this.id = id;
    this.title = title;
}

function Category(raw) {
    this.raw = raw;
}
Category.prototype.getId = function () {
    if (this.raw) {
        return this.raw?.id;
    }
    return "";
};
Category.prototype.getTitle = function () {
    if (this.raw) {
        return this.raw?.title;
    }
    return "";
};

function Keyword(raw) {
    this.raw = raw;
}
Keyword.prototype.getId = function () {
    if (this.raw) {
        return this.raw?.id;
    }
    return "";
};
Keyword.prototype.getTitle = function () {
    if (this.raw) {
        return this.raw?.title;
    }
    return "";
};


function LpPage() {
    Page.call(this, "lp", "検索受けページ");
    this.categoryId = "";
    this.selecteds = [];
    this.expectations = [];
    this.categories = [];
    this.keywords = [];
}
tacklebox.design.extend(LpPage, Page);
LpPage.prototype.isSelected = function () {
    return this.selecteds.length > 0;
};
LpPage.prototype._onInitialize = function () {
    const self = this;
    fetch(process.env.VUE_APP_HACHIWARE + "/needs/category/" + this.categoryId)
        .then((response) => response.json())
        .then((json) => {
            for (let i in json.data) {
                self.expectations.push(
                    new Expectation(
                        json.data[i].id,
                        json.data[i].title,
                    )
                );
            }
        })
        .catch((error) => {
            tacklebox.e(error)
        })

    fetch(process.env.VUE_APP_HACHIWARE + "/categories/" + this.categoryId + "/relatives")
        .then((response) => response.json())
        .then((json) => {
            for (let i in json.data) {

                if (json.data[i]?.title) {
                    if (json.data[i]?.title.indexOf("（仮）") < 0) {
                        self.categories.push(
                            new Category(
                                json.data[i]
                            )
                        );
                    }
                }                
            }
        })
        .catch((error) => {
            tacklebox.e(error)
        })

    fetch(process.env.VUE_APP_HACHIWARE + "/keywords/category/" + this.categoryId)
        .then((response) => response.json())
        .then((json) => {
            for (let i in json.data) {
                self.keywords.push(
                    new Keyword(
                        json.data[i]
                    )
                );
            }
        })
        .catch((error) => {
            tacklebox.e(error)
        })

};
LpPage.prototype.select = function (expectation_id) {
    for (let i = 0; i < this.selecteds.length; i++) {
        let sid = this.selecteds[i];
        if (sid == expectation_id) {
            this.selecteds.splice(i, 1);
            return;
        }
    }
    this.selecteds.push(expectation_id);
};
LpPage.prototype.startInterview = function (callback = (interview_id) => { tacklebox.d(interview_id) }) {
    let rbody = {
        "id": this.categoryId,
        "requires": [
        ],
        "ignores": [
        ],
        "session": "x"
    };

    for (let i in this.selecteds) {
        rbody.requires.push(this.selecteds[i]);
    }

    fetch(process.env.VUE_APP_HACHIWARE + "/interviews/entry/search/category", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(rbody)
    })
        .then((response) => response.json())
        .then((json) => {
            if (callback) {
                callback(json.data.id);
            }
        })
        .catch((error) => {
            tacklebox.e(error)
            if (callback) {
                callback(null);
            }
        });
};

export { LpPage }
